module.exports = __webpack_public_path__ + "img/yszc-gszc-qm.209034f2.png";